import * as trackingKeys from 'actions/trackingKeys'
import { client as clientRoutes } from 'config/routes'

export type FooterLinkData = {
  label: string
  href: string
  testid: string
  trackingActionType?: string
}

export type FooterColumnData = {
  heading: string
  links: FooterLinkData[]
}

export const RECIPE_BOXES: FooterLinkData[] = [
  {
    label: 'Gousto recipe boxes',
    href: clientRoutes.foodBox,
    testid: 'footer-food-box',
    trackingActionType: trackingKeys.bofuFoodBox,
  },
  {
    label: 'Meal boxes for one',
    href: '/food-box/meal-boxes-for-one',
    testid: 'footer-meal-boxes-for-one',
    trackingActionType: trackingKeys.bofuMealsForOne,
  },
  {
    label: 'Healthy meal boxes',
    href: '/food-box/healthy-meal-boxes',
    testid: 'footer-healthy-meal-boxes',
    trackingActionType: trackingKeys.bofuHealthyFoodBoxes,
  },
  {
    label: 'Family meal boxes',
    href: '/food-box/family-meal-boxes',
    testid: 'footer-family-meal-boxes',
    trackingActionType: trackingKeys.bofuFamilyMealBoxes,
  },
  {
    label: 'Low calorie meals',
    href: '/food-box/low-calorie-meal-boxes',
    testid: 'footer-low-calorie-meal-boxes',
    trackingActionType: trackingKeys.bofuLowCalorieMealsDelivered,
  },
  {
    label: 'Vegan meal boxes',
    href: '/food-box/vegan-meal-boxes',
    testid: 'footer-vegan-meal-boxes',
    trackingActionType: trackingKeys.bofuVeganMealBoxes,
  },
  {
    label: 'Vegetarian meal boxes',
    href: '/food-box/vegetarian-meal-boxes',
    testid: 'footer-vegetarian-meal-boxes',
    trackingActionType: trackingKeys.bofuVegetarianMealBox,
  },
  {
    label: 'Pescatarian meal boxes',
    href: '/food-box/pescatarian-meal-boxes',
    testid: 'footer-pescatarian-meal-boxes',
    trackingActionType: trackingKeys.bofuPescatarianFoodBoxes,
  },
  {
    label: 'Meal prep delivery',
    href: '/food-box/meal-prep-boxes',
    testid: 'footer-meal-prep-boxes',
    trackingActionType: trackingKeys.bofuMealPrepServices,
  },
]

export const OUR_RECIPES: FooterColumnData = {
  heading: 'Our recipes',
  links: [
    {
      label: 'This week’s recipes',
      href: clientRoutes.menu,
      testid: 'footer-this-weeks-recipes',
      trackingActionType: trackingKeys.clickRecipeNavigationFooter,
    },
    {
      label: 'All Gousto recipes',
      href: clientRoutes.cookbookAllRecipes,
      testid: 'footer-all-recipes',
    },
  ],
}

export const COMPANY: FooterColumnData = {
  heading: 'Company',
  links: [
    { label: 'Blog', href: clientRoutes.blog, testid: 'footer-blog' },
    { label: 'Sustainability', href: clientRoutes.weCare, testid: 'footer-we-care' },
    { label: 'Our Suppliers', href: clientRoutes.ourSuppliers, testid: 'footer-our-suppliers' },
    { label: 'Jobs', href: clientRoutes.jobs, testid: 'footer-jobs' },
  ],
}
